import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as CloseModalImg } from "../../../assets/images/closeModalImg.svg";
import { Dialog } from "@mui/material";
import FileAttachment from "../../UniversalComponents/FileAttachment";

const ApproverDialogue = ({ open, close, onSubmit }) => {
  return (
    <Dialog open={open} fullWidth onClose={close}>
      <div className="p-4 w-full h-full">
        <div className="flex justify-between items-center">
          <span className="text-2C495D font-semibold text-xl">Upload File</span>
          <button
            onClick={close}
            type="button"
            className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex flex end-0 items-center"
            data-modal-hide="assets-modal"
          >
            <CloseModalImg className="w-3 h-3" />
            <span className="sr-only flex float-end">Close modal</span>
          </button>
        </div>
        <div className="border w-full mt-2"></div>

        <div className="border-none b w-full h-44 text-center mt-5">
          <p>Kindly, attached document</p>
          <p>Tax Paper1</p>
          <p>tax Paper2</p>
          <p>Tax Paper3</p>
        </div>

        {/* Attachement  part */}
        {/* 
        <div className="text-[#434852] text-14 text-600 font-semibold">
          Attachments(0)
          <span className="text-10"> Maximum Size 20 MB</span>
        </div> */}

        <FileAttachment />

        {/* <div className=" border rounded-md bg-white w-full h-full justify-center flex flex-col items-center pb-5">
          <div className="border-none h-10 mt-5  ">Drop files here or click to select from the device</div>
          <div className="border rounded-md h-10 mt-5 bg-[#EAE2E2]">Upload from this device</div>
        </div> */}

        <div className="flex justify-end py-4  text-md w-full">
          <div className="px-6">
            <button onClick={onSubmit} type="button" className="w-28 text-[#FFFFFF] bg-[#1D4469]  rounded-md py-3 px-3">
              send
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default ApproverDialogue;
